import React, { lazy } from 'react';
import { StarIcon, CheckCircleIcon } from 'lucide-react';
import { CART_URL } from '../utils/constants';
import { trackAddToCart } from '../utils/metaPixel';
const testimonialImages = ['https://cdn.magicpatterns.com/uploads/r51KjPvdV8WmvHLpPK15Kr/hf_20260315_182837_6ab9efa5-5df0-4c66-b52f-6c24ec36b860.jpg', 'https://cdn.magicpatterns.com/uploads/hTnPFUpppnP3LoAmQttG8H/hf_20260315_183222_7a83e665-5e43-4307-9a25-a08b1b8260ba.jpg', 'https://cdn.magicpatterns.com/uploads/qs2HhjFphRGis7G7RoUDMJ/hf_20260315_183954_b5279132-6968-4655-ad46-ff1bb72e7ba3.jpg', 'https://cdn.magicpatterns.com/uploads/4tE72iEqugvUTRNaym3n2c/hf_20260315_183606_d9905e3b-435b-4fb0-b6ab-f4426ab64245.jpg', 'https://cdn.magicpatterns.com/uploads/ayzdfMy37Xcjc5cxzpg9gy/hf_20260315_184201_1e5f37a1-31d2-4735-bd4e-105cbbf68164.jpg'];
export function StudentReviews() {
  return <>
      <section className="py-8 md:py-20 px-4 bg-[#FFF8F0]" data-id="element-247">
        <div className="max-w-2xl mx-auto" data-id="element-248">
          <div className="bg-cta-green text-white text-center font-bold py-3 md:py-4 px-4 rounded-[10px] mb-5 md:mb-8 shadow-md" data-id="element-249">
            ✅ Más de <strong className="text-[110%]" data-id="element-250">2.137</strong> mujeres ya
            están ganando dinero extra con este método
          </div>

          <h2 className="text-2xl md:text-4xl font-heading font-bold text-center text-brown-dark mb-3 md:mb-6" data-id="element-251">
            Lo que dicen las chicas💞
          </h2>

          <div className="flex flex-col items-center mb-4 md:mb-10" data-id="element-252">
            <div className="flex items-center gap-2 mb-1.5" data-id="element-253">
              <span className="text-4xl md:text-6xl font-heading font-extrabold text-brown-dark" data-id="element-254">
                4.9
              </span>
              <div className="flex flex-col" data-id="element-255">
                <div className="flex gap-0.5" data-id="element-256">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 md:w-7 md:h-7 fill-caramel text-caramel" data-id="element-257" />)}
                </div>
                <span className="text-xs md:text-sm text-gray-500 font-medium mt-0.5" data-id="element-258">
                  Basado en +<strong className="text-[110%]" data-id="element-259">2037</strong>{' '}
                  reseñas
                </span>
              </div>
            </div>
          </div>

          <div className="flex flex-col space-y-3 md:space-y-4" data-id="element-260">
            {testimonialImages.map((src, i) => <div key={i} className={`w-[95%] md:w-[90%] ${i % 2 === 0 ? 'self-start mr-auto' : 'self-end ml-auto'}`} data-id="element-261">
                <img src={src} alt={`Testimonio de clienta ${i + 1}`} className="w-full rounded-[10px] shadow-[0_2px_8px_rgba(0,0,0,0.08)] border border-gray-200" loading="lazy" data-id="element-262" />
              </div>)}
          </div>
        </div>
      </section>

      {/* Emotional Bridge CTA */}
      <section className="py-6 md:py-10 px-4 bg-[#FAFAF8]" data-id="element-263">
        <div className="max-w-xl mx-auto text-center" data-id="element-264">
          <div className="w-12 h-px bg-gray-300 mx-auto mb-4 md:mb-5" data-id="element-265" />

          <p className="italic text-gray-500 text-base md:text-lg mb-5 md:mb-6 leading-relaxed px-2" data-id="element-266">
            "Ellas empezaron exactamente desde donde estás tu ahora."
          </p>

          <a href={CART_URL} onClick={e => {
          e.preventDefault();
          trackAddToCart();
          try {
            window.top!.location.href = CART_URL;
          } catch {
            window.location.href = CART_URL;
          }
        }} className="block w-full md:w-auto md:inline-block bg-[#2D7A3A] hover:bg-[#246B31] text-white font-heading font-bold text-base md:text-xl py-4 md:py-5 px-8 md:px-12 rounded-xl shadow-[0_4px_16px_rgba(45,122,58,0.35)] transition-all transform hover:-translate-y-1 hover:scale-[1.02] uppercase tracking-wide mb-3 md:mb-4" data-id="element-267">
            QUIERO SER LA PRÓXIMA — ACCESO INMEDIATO POR $17
          </a>

          <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-1.5 text-xs md:text-sm text-gray-400 font-medium" data-id="element-268">
            <span className="flex items-center gap-1" data-id="element-269">
              <CheckCircleIcon className="w-3.5 h-3.5 text-gray-400" data-id="element-270" />
              Acceso inmediato por email
            </span>
            <span className="flex items-center gap-1" data-id="element-271">
              <CheckCircleIcon className="w-3.5 h-3.5 text-gray-400" data-id="element-272" />
              Pago único
            </span>
            <span className="flex items-center gap-1" data-id="element-273">
              <CheckCircleIcon className="w-3.5 h-3.5 text-gray-400" data-id="element-274" />
              Sin suscripciones
            </span>
          </div>
        </div>
      </section>
    </>;
}